import React, { useRef } from 'react';
import './MiniMusicPlayer.css';
import playPauseIcon from '../img/play-pause.png';
import playIcon from '../img/play.png';
import pauseIcon from '../img/pause.png';
import skipIcon from '../img/skip.png';

interface MiniMusicPlayerProps {
  isPlaying: boolean;
  currentTrack: string;
  onPlayPause: () => void;
  onNext: () => void;
  onPrev: () => void;
  isOpen: boolean;
  onToggle: (e: React.MouseEvent<HTMLDivElement>) => void;
  onHover: (e: React.MouseEvent<HTMLDivElement>) => void;
  onClose: () => void;
  menuPosition: { x: number; y: number };
  isMobile?: boolean;
  iconRef?: React.RefObject<HTMLDivElement | null>;
}

const MiniMusicPlayer: React.FC<MiniMusicPlayerProps> = ({
  isPlaying,
  currentTrack,
  onPlayPause,
  onNext,
  onPrev,
  isOpen,
  onToggle,
  onHover,
  onClose,
  menuPosition,
  isMobile = false,
  iconRef: externalIconRef
}) => {
  const internalIconRef = useRef<HTMLDivElement>(null);
  const iconRef = externalIconRef || internalIconRef;

  return (
    <div
      ref={iconRef}
      className={`mini-music-player-icon ${isOpen ? 'active' : ''}`}
      onClick={onToggle}
      onMouseEnter={onHover}
    >
      <img src={playPauseIcon} alt="Music Player" />
    </div>
  );
};

export default MiniMusicPlayer;
